import { useEffect } from "react";
import mediaUrlAdapter from "../api/Media/mediaUrlAdapter";
import UserAuthStore from "../store/userStore";
import useResolvedMediaUrlStore from "../store/useResolvedMediaUrlStore";

/**
 * Resolves a storage path to a signed URL, caching via zustand.
 * If isStoragePath is false, returns src unchanged.
 */
export default function useResolvedMediaUrl(src, isStoragePath) {
  const setLoadedUrl = useResolvedMediaUrlStore((s) => s.setLoadedUrl);
  const cachedUrl = useResolvedMediaUrlStore((s) => (src ? s.urls[src] : null));

  useEffect(() => {
    if (!src || !isStoragePath || cachedUrl) return;
    let cancelled = false;
    (async () => {
      try {
        const isAsset = src.startsWith("asset_");
        const url = isAsset
          ? (await mediaUrlAdapter.resolveAsset(src))?.url
          : await mediaUrlAdapter.getUrl(src, UserAuthStore.getState().orgId);
        if (url && !cancelled) setLoadedUrl(src, url);
      } catch (_) { /* ignore */ }
    })();
    return () => { cancelled = true; };
  }, [src, isStoragePath, cachedUrl, setLoadedUrl]);

  return isStoragePath ? cachedUrl : src;
}
